import { render, staticRenderFns } from "./RemoteUpgradeList.vue?vue&type=template&id=773c2ce9&scoped=true&"
import script from "./RemoteUpgradeList.vue?vue&type=script&lang=js&"
export * from "./RemoteUpgradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c2ce9",
  null
  
)

export default component.exports